import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthRoutes } from '../../constants/Constants'; 
import { refreshLLMMappings } from '../../service/MasterService';

const RefreshAgentList = () => {
  const [message, setMessage] = useState('Refreshing agent mappings, please wait...');
  const navigate = useNavigate();

  useEffect(() => {
    const triggerRefresh = async () => {
      const response = await refreshLLMMappings();

      if (response && response.status === 200) {
        setMessage(response.data + ' You will be redirected shortly.');
      } else {
        setMessage('An error occurred while refreshing the agent list. Please contact support.');
      }
      setTimeout(() => { 
        navigate(AuthRoutes.STUDYLIST);
      }, 3000);
    };

    triggerRefresh();
  }, [navigate]); 

  return (
    <div style={{ padding: '50px', textAlign: 'center', fontSize: '20px' }}>
      <h1>{message}</h1>
    </div>
  );
};

export default RefreshAgentList;